import React, { Component } from "react";
import { connect } from "react-redux";
import ApiConfig from "../../constants/ApiConfig";

class SidebarHeader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      loaded: true,
    };
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.user.cutomerRef !== this.props.user.customerRef) {
      // this.load()
    }
    // this.load()
  }



  render() {
    const { data } = this.state;

    return (
      <div className="sidebar-header">

        <div>
          <small>
            {this.props.user.customerRef
              ? this.props.user.customerRef
              : data.id}
          </small>
        </div>
        <div>
          <small>
             {this.props.user.name}
          </small>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { user: state.user };
};

const mapDispatchToProps = (dispatch) => ({});

module.exports = connect(mapStateToProps, mapDispatchToProps)(SidebarHeader);



// WEBPACK FOOTER //
// ./src/components/SidebarHeader/SidebarHeader.js